import { CreateInstance } from "./config"
const UserEntityRegisterAPI = CreateInstance("user-entity-register")
const UserEntityRegisterNotTokeAPI = CreateInstance("user-entity-register-not-token")
export default UserEntityRegisterAPI
